import { toast, ToastContentProps } from 'react-toastify'

import InfoBox, {
  InfoBoxIconPosition,
  InfoBoxType,
} from '@/Atomic/Molecules/InfoBox'

import './InfoBoxToast.scss'

interface InfoBoxToastProps extends Partial<ToastContentProps> {
  type: InfoBoxType
  text: string
  subtext?: string
  actionLabel?: string
  onAction?: () => void
  iconPosition?: InfoBoxIconPosition
}

const InfoBoxToast = ({
  closeToast,
  type,
  text,
  subtext,
  actionLabel,
  onAction,
  iconPosition = 'side',
}: InfoBoxToastProps) => (
  <InfoBox
    type={type}
    iconPosition={iconPosition}
    onClose={() => closeToast?.()}
  >
    <div>
      <div className="info-box-toast-text">{text}</div>
      {subtext && <div className="info-box-toast-subtext">{subtext}</div>}
      {actionLabel && onAction && (
        <button
          type="button"
          className="info-box-toast-action"
          onClick={() => {
            onAction()
            closeToast?.()
          }}
        >
          {actionLabel}
        </button>
      )}
    </div>
  </InfoBox>
)

export function showInfoBoxToast(
  props: Pick<
    InfoBoxToastProps,
    'type' | 'text' | 'subtext' | 'actionLabel' | 'onAction' | 'iconPosition'
  >,
) {
  toast(<InfoBoxToast {...props} />)
}
